import { Routes, Route } from "react-router-dom";

import PushingTugPlanning from "./PushingTugPlanning";

const index = () => {
	return (
		<Routes>
			<Route index element={<PushingTugPlanning />} />
		</Routes>
	);
};

export default index;
